import {
  Component,
  OnInit,
  Renderer2,
  ElementRef,
  ViewChild,
  EventEmitter,
} from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { CommonService } from '../../../../shared/services/common.service'
import { Router, ActivatedRoute } from '@angular/router'
import { Observable, of } from 'rxjs'
import { FormControl, FormGroup, FormBuilder } from '@angular/forms'
import {
  CmsService,
  AuthService,
  User,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { switchMap } from 'rxjs/operators'

import { Output } from '@angular/core'
import { UserAccountFacade } from '@spartacus/user/account/root'
@Component({
  standalone: false,
  selector: 'vs-personal-detail',
  templateUrl: './personal-detail.component.html',
  styleUrls: ['./personal-detail.component.scss'],
})
export class PersonalDetailComponent implements OnInit {
  public userTypes
  public showDiv = false
  public userRoleModel = ''
  public userRoles = 'userRoles'
  user$: Observable<User>
  myprofile: FormGroup
  userId = ''
  myprofiledetails: FormGroup
  myprofilenotify: FormGroup
  personaldetail: FormGroup
  comments: string
  public showInfo = false
  public roleObj
  comment: any
  requestRoleChange: boolean = false
  displayRoleMatrix: boolean = false

  @Output() rolesMatrixEvent = new EventEmitter()

  @ViewChild('successMsgOne') successMsgOne: ElementRef
  @ViewChild('infoMsg', { static: false }) infoMsg: ElementRef
  @ViewChild('successMsg', { static: false }) successMsg: ElementRef
  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private router: Router,
    private cmsService: CmsService,
    private auth: AuthService,

    private renderer: Renderer2,
    private el: ElementRef,
    private globalMessageService: GlobalMessageService,
    private activatedRoute: ActivatedRoute,
    private userAccountFacade: UserAccountFacade
  ) {
    this.personaldetail = this.formBuilder.group({
      fname: new FormControl(''),
      lname: new FormControl(''),
      ssoid: new FormControl(''),
      email: new FormControl(''),
      lastlogin: new FormControl(''),
      roleform: new FormControl(''),
      accesslevel: new FormControl(''),
      userRoles: new FormControl(''),
      reqcomment: new FormControl(''),
    })
  }
  get getpersonaldetail() {
    return this.personaldetail.controls
  }

  get fname() {
    return this.personaldetail.get('fname')
  }
  get ssoid() {
    return this.personaldetail.get('ssoid')
  }
  get lname() {
    return this.personaldetail.get('lname')
  }
  get email() {
    return this.personaldetail.get('email')
  }
  get lastlogin() {
    return this.personaldetail.get('lastlogin')
  }
  get role() {
    return this.personaldetail.get('role')
  }
  get accesslevel() {
    return this.personaldetail.get('accesslevel')
  }
  get requestrole() {
    return this.personaldetail.get('requestrole')
  }
  get reqcomment() {
    return this.personaldetail.get('reqcomment')
  }
  goToTop() {
    window.scrollTo(0, 0)
  }

  getCustomerData() {
    const params = ['users', 'current', 'myprofile']
    const apiUrl = this.commonService.constructUrl(params)

    this.commonService.getData(apiUrl).subscribe(
      (success) => {
        this.userTypes = success
        if (this.userTypes) {
          this.showDiv = this.userTypes.isRoleChanged
          if (!this.userTypes.isRoleChanged) {
            this.globalMessageService.add(
              { key: 'myProfile.requestForRoleChange' },
              GlobalMessageType.MSG_TYPE_INFO,
              180000
            )
            // this.infoMsg.nativeElement.style.display = 'block';
            //  this.showInfo = true;
          }
          this.userRoleModel = this.userTypes.requestForRoleChange[0]
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  getRoleChange() {
    this.roleObj = {
      role: this.userRoleModel,
      comments: this.personaldetail.value.reqcomment,
    }
    this.commonService
      .postData(
        environment.occBaseUrl +
          '/occ/v2/vsstore/users/current/roleChange?role=' +
          this.roleObj.role +
          '&comments=' +
          this.roleObj.comments +
          '',
        this.roleObj
      )
      .subscribe(
        (success) => {
          //  this.showInfo = true;
          //this.infoMsg.nativeElement.style.display = 'block';
          this.requestRoleChange = false
          this.globalMessageService.add(
            { key: 'myProfile.requestForRoleChange' },
            GlobalMessageType.MSG_TYPE_INFO,
            60000
          )
          this.goToTop()
          this.showDiv = false
        },
        (error) => {
          this.requestRoleChange = false
          this.globalMessageService.add(
            { key: 'myProfile.issueWhileRoleChange' },
            GlobalMessageType.MSG_TYPE_INFO,
            5000
          )
        }
      )
  }

  getComment() {}
  clearPersonalDetails() {
    this.personaldetail.reset()
    this.getCustomerData()
  }

  displayRoleChange() {
    this.requestRoleChange = true
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((success) => {})
    this.getCustomerData()
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )
    this.user$.subscribe((success) => {})
  }

  displayRolesOverlay() {
    // this.displayRoleMatrix = true;
    this.rolesMatrixEvent.emit('true')
  }
}
